import AutoCompleteFilter from "../../../../components/AutoCompleteFilter";
import baseService from "../../../../services/baseService";

export const inputsFiltersEntrance = ({
  localFilterValues,
  handleFilterChange,
}) => [
  {
    label: "Número do Documento",
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="doc_number"
        model="transaction"
        value={localFilterValues["doc_number"]}
        onChange={(selected) => handleFilterChange("doc_number", selected)}
        placeholder="Filtre pelo número do documento"
        isMulti
        isClearable
      />
    ),
  },
  {
    label: "Fornecedor",
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="name"
        model="supplier"
        value={localFilterValues["supplier.name"]}
        onChange={(selected) => handleFilterChange("supplier.name", selected)}
        placeholder="Filtre pelo fornecedor"
        isMulti
        isClearable
      />
    ),
  },
  {
    label: "Tipo de Documento",
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="name"
        model="documentType"
        value={localFilterValues["documentType.name"]}
        onChange={(selected) => handleFilterChange("documentType.name", selected)}
        placeholder="Filtre pelo tipo de documento"
        isMulti
        isClearable
      />
    ),
  },
  {
    label: "Comprador",
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="name"
        model="organization"
        value={localFilterValues["buyer.name"]}
        onChange={(selected) => handleFilterChange("buyer.name", selected)}
        placeholder="Filtre pelo comprador"
        isMulti
        isClearable
      />
    ),
  },
  {
    label: "Produto",
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="name"
        model="product"
        value={localFilterValues["items.product.name"]}
        onChange={(selected) =>
          handleFilterChange("items.product.name", selected)
        }
        placeholder="Filtre pelo produto"
        isMulti
        isClearable
      />
    ),
  },
  {
    label: "Categoria",
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="name"
        model="category"
        value={localFilterValues["items.category.name"]}
        onChange={(selected) =>
          handleFilterChange("items.category.name", selected)
        }
        placeholder="Filtre pela categoria"
        isMulti
        isClearable
      />
    ),
  },
  {
    label: "Condição",
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="name"
        model="condition"
        value={localFilterValues["items.condition.name"]}
        onChange={(selected) =>
          handleFilterChange("items.condition.name", selected)
        }
        placeholder="Filtre pela condição"
        isMulti
        isClearable
      />
    ),
  },
  {
    label: "Apelido do Endereço",
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="alias"
        model="address"
        value={localFilterValues["items.address.alias"]}
        onChange={(selected) =>
          handleFilterChange("items.address.alias", selected)
        }
        placeholder="Filtre pelo apelido do endereço"
        isMulti
        isClearable
      />
    ),
  },
  {
    label: "Rua do Endereço",
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="street"
        model="address"
        value={localFilterValues["items.address.street"]}
        onChange={(selected) =>
          handleFilterChange("items.address.street", selected)
        }
        placeholder="Filtre pela rua do endereço"
        isMulti
        isClearable
      />
    ),
  },
  {
    label: "Cidade",
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="city"
        model="address"
        value={localFilterValues["items.address.city"]}
        onChange={(selected) =>
          handleFilterChange("items.address.city", selected)
        }
        placeholder="Filtre pela cidade do endereço"
        isMulti
        isClearable
      />
    ),
  },
  {
    label: "Estado",
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="state"
        model="address"
        value={localFilterValues["items.address.state"]}
        onChange={(selected) =>
          handleFilterChange("items.address.state", selected)
        }
        placeholder="Filtre pelo estado do endereço"
        isMulti
        isClearable
      />
    ),
  },
];

export const inputsFiltersDerparture = ({
  localFilterValues,
  handleFilterChange,
}) => [
  {
    label: "Apelido do Endereço",
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="alias"
        model="address"
        value={localFilterValues["items.address.alias"]}
        onChange={(selected) =>
          handleFilterChange("items.address.alias", selected)
        }
        placeholder="Filtre pelo apelido do endereço"
        isMulti
        isClearable
      />
    ),
  },
  {
    label: "Rua do Endereço",
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="street"
        model="address"
        value={localFilterValues["items.address.street"]}
        onChange={(selected) =>
          handleFilterChange("items.address.street", selected)
        }
        placeholder="Filtre pela rua do endereço"
        isMulti
        isClearable
      />
    ),
  },
  {
    label: "Cidade",
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="city"
        model="address"
        value={localFilterValues["items.address.city"]}
        onChange={(selected) =>
          handleFilterChange("items.address.city", selected)
        }
        placeholder="Filtre pela cidade do endereço"
        isMulti
        isClearable
      />
    ),
  },
  {
    label: "Estado",
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="state"
        model="address"
        value={localFilterValues["items.address.state"]}
        onChange={(selected) =>
          handleFilterChange("items.address.state", selected)
        }
        placeholder="Filtre pelo estado do endereço"
        isMulti
        isClearable
      />
    ),
  },
];

export const inputsFiltersTransfer = ({
  localFilterValues,
  handleFilterChange,
}) => [
  {
    label: "Apelido do Endereço",
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="alias"
        model="address"
        value={localFilterValues["items.address.alias"]}
        onChange={(selected) =>
          handleFilterChange("items.address.alias", selected)
        }
        placeholder="Filtre pelo apelido do endereço"
        isMulti
        isClearable
      />
    ),
  },
  {
    label: "Rua do Endereço",
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="street"
        model="address"
        value={localFilterValues["items.address.street"]}
        onChange={(selected) =>
          handleFilterChange("items.address.street", selected)
        }
        placeholder="Filtre pela rua do endereço"
        isMulti
        isClearable
      />
    ),
  },
  {
    label: "Cidade",
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="city"
        model="address"
        value={localFilterValues["items.address.city"]}
        onChange={(selected) =>
          handleFilterChange("items.address.city", selected)
        }
        placeholder="Filtre pela cidade do endereço"
        isMulti
        isClearable
      />
    ),
  },
  {
    label: "Estado",
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="state"
        model="address"
        value={localFilterValues["items.address.state"]}
        onChange={(selected) =>
          handleFilterChange("items.address.state", selected)
        }
        placeholder="Filtre pelo estado do endereço"
        isMulti
        isClearable
      />
    ),
  },
];

export const inputsFiltersInternalUse = ({
  localFilterValues,
  handleFilterChange,
}) => [
  {
    label: "Apelido do Endereço",
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="alias"
        model="address"
        value={localFilterValues["items.address.alias"]}
        onChange={(selected) =>
          handleFilterChange("items.address.alias", selected)
        }
        placeholder="Filtre pelo apelido do endereço"
        isMulti
        isClearable
      />
    ),
  },
  {
    label: "Rua do Endereço",
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="street"
        model="address"
        value={localFilterValues["items.address.street"]}
        onChange={(selected) =>
          handleFilterChange("items.address.street", selected)
        }
        placeholder="Filtre pela rua do endereço"
        isMulti
        isClearable
      />
    ),
  },
  {
    label: "Cidade",
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="city"
        model="address"
        value={localFilterValues["items.address.city"]}
        onChange={(selected) =>
          handleFilterChange("items.address.city", selected)
        }
        placeholder="Filtre pela cidade do endereço"
        isMulti
        isClearable
      />
    ),
  },
  {
    label: "Estado",
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="state"
        model="address"
        value={localFilterValues["items.address.state"]}
        onChange={(selected) =>
          handleFilterChange("items.address.state", selected)
        }
        placeholder="Filtre pelo estado do endereço"
        isMulti
        isClearable
      />
    ),
  },
];
